export default function () {
   const list = document.querySelector('#navbar-menu');
   const item = list.querySelector('.current.active');
   const line = list.querySelector('#line');
   let lineWidth = item.getBoundingClientRect().left;
   line.style.width = lineWidth +'px';
   console.log(list);
   console.log();
}


// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/lineGrower.js